/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */

'use strict';

module.exports = {
  read: function (str) {
    return str;
  },
  write: function (obj) {
    return obj.toString();
  }
};